<template>
  <div class="flex gap-[.35em]" :class="isAvailable ? 'text-green-500' : 'text-red-700'">
    <CheckCircleIcon v-if="isAvailable" class="size-[1.5em] shrink-0" />
    <XCircleIcon v-else class="size-[1.5em] shrink-0" />
    <span>
      {{ isAvailable ? 'Maahantuojalla' : 'Ei maahantuojalla' }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/24/solid'

defineProps({
  isAvailable: {
    type: Boolean,
    required: true,
    default: false
  }
})
</script>
